import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { branch, compose, renderComponent } from 'recompose'
import T from 'i18n-react'

import Notification from 'containers/App/Notification/index'
import AsyncHoc from 'containers/Async/AsyncProgressBarHoc'
import Layout from './Layout'
import Card from './Card'
import CardTitle from './CardTitle'
import Input from './Input'
import Button from './Button'
import Image from './Image'

import { USER_TYPE } from 'config.js'
import styles from './styles.scss'

import {
  DEFAULT_REDIRECT,
  POST_LOGIN_USER,
} from './constants'

import {
  updateUsername,
  updatePassword,
  postLoginUser,
} from './actions'

import {
  usernameSelector,
  passwordSelector,
  authenticatedSelector,
  showErrorSelector,
} from './selectors'

const onEnter = (callback) => (event) => {
  switch (event.key) {
    case 'Enter': return callback(event)
  }
}

const mapStateToProps = (state) => {
  return {
    username: usernameSelector(state),
    password: passwordSelector(state),
    authenticated: authenticatedSelector(state),
    showError: showErrorSelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onEnter: onEnter(() => dispatch(postLoginUser())),
    onNext: () => dispatch(postLoginUser()),
    onPasswordChange: password => dispatch(updatePassword(password)),
    onUsernameChange: username => dispatch(updateUsername(username)),
  }
}

const AsyncButton = AsyncHoc(Button)([POST_LOGIN_USER])

const LoginPage = props => {
  const {
    onEnter,
    onNext,
    onUsernameChange,
    onPasswordChange,
    username,
    password,
    showError
  } = props

  return (
    <Layout>
      <Card>
        <Image src='/images/NVLogo_2D_H.png' />
        <CardTitle />
        <Input
          label='Email'
          onChange={onUsernameChange}
          onKeyPress={onEnter}
          value={username}
          error={showError ? ' ' : ''}
          showError={showError}
        >
          {(username && USER_TYPE === 'internal')
            ? <span id={styles.suffix}>@nvidia.com</span>
            : null
          }
        </Input>
        <Input
          label='Password'
          type='password'
          onChange={onPasswordChange}
          value={password}
          onKeyPress={onEnter}
          error={showError ?
            (USER_TYPE === 'internal'
              ? T.translate('containers.user.login.input.internal_user.error')
              : T.translate('containers.user.login.input.external_user.error'))
            : ''}
          showError={showError}
        />
        <AsyncButton
          label='Next'
          onClick={onNext}
        />
      </Card>
      <Notification />
    </Layout>
  )
}


const RedirectTo = (props) => {
  const { from } = props.location.state || DEFAULT_REDIRECT
  return (
    <Redirect to={from} />
  )
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withRedirect = branch(
  ({ authenticated }) => authenticated,
  renderComponent(RedirectTo)
)
const enhance = compose(
  withConnect,
  withRedirect,
)

export default enhance(LoginPage)
